/** Select móvil con etiqueta fija y opciones del servidor. */
import { clsx } from 'clsx';
import type { SelectHTMLAttributes } from 'react';

export type MobileSelectOption = {
  value: string;
  label: string;
};

type MobileSelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  label: string;
  options: MobileSelectOption[];
  staticLabel?: boolean;
  isRequired?: boolean;
  error?: string;
};

export function MobileSelect({
  label,
  options,
  staticLabel = false,
  isRequired = false,
  error,
  id,
  className,
  ...props
}: MobileSelectProps) {
  const selectId = id ?? `select-${label.replace(/\s+/g, '-').toLowerCase()}`;
  return (
    <div>
      <label
        htmlFor={selectId}
        className={clsx(
          'mb-1.5 block break-words text-sm font-medium text-text-secondary',
          !staticLabel && 'sr-only',
        )}
      >
        {label}
        {isRequired && (
          <span aria-hidden="true" className="text-error"> *</span>
        )}
      </label>
      <select
        id={selectId}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${selectId}-error` : undefined}
        className={clsx(
          'h-12 w-full rounded-xl border-[1.5px] bg-white px-3 text-sm text-text-primary focus:outline-none',
          error ? 'border-error focus:border-error' : 'border-border focus:border-primary',
          className,
        )}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p id={`${selectId}-error`} className="mt-1.5 break-words text-sm text-error">
          {error}
        </p>
      )}
    </div>
  );
}
